module.exports = [
  require("./Header"),
  require("./TextImageBottom"),
  require("./TextVideoBottom"),
  require("./TextFeaturesImageAside"),
  require("./Gallery"),
  require("./FAQ"),
  require("./FAQAccordion"),
  require("./FeaturesToSucceed"),
  require("./TextImageLeft"),
  require("./Footer"),
];
